module.exports = __webpack_public_path__ + "img/es-mb-banner.a56a323d.png";